module.exports = __webpack_public_path__ + "bbdea243da84f7347b44390e25e21738.png";


//////////////////
// WEBPACK FOOTER
// ./src/logos/eiyahon.png
// module id = 71
// module chunks = 0